import React, {FC, useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import ReadCode from "./read-code";
import ReadWriteContract from "./read-write-contract";
import {useTranslation} from "react-i18next";
import {addressService} from "../../../store/actions";
import AuditPage from "./ai-audit";

interface ContractDetailsData {
    data?: any;
    is_verified?: boolean;
    has_methods_read?: boolean;
    has_methods_read_proxy?: boolean;
    has_methods_write?: boolean;
    has_methods_write_proxy?: boolean;
}

const ContractDetails: FC<ContractDetailsData> = (props) => {
    const location = useLocation();
    const hashSplit = location.hash.split("#");
    const [tab, setTab] = useState(hashSplit?.[1] ?? "code");
    const {t, i18n} = useTranslation();
    const {address, token} = useParams();
    const [loading, setLoading] = useState(true);
    const [details, setDetails] = useState<ContractDetailsData>({
        is_verified: true,
        has_methods_read: true,
        has_methods_read_proxy: true,
        has_methods_write: true,
        has_methods_write_proxy: true,
    });

    const getVerifiedContract = async () => {
        try {
            setLoading(true);
            addressService
                .getVerifiedAddress(address || token, "")
                .then((response) => {
                    setDetails(response);
                    setLoading(false);
                })
                .catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        getVerifiedContract();
    }, []);

    const handleTab = (e: string) => {
        setTab(e);
        if (!!e?.length) window.location.hash = `#${e}`;
        else {
            window.location.hash = "";
            //@ts-ignore
            window.history.replaceState(null, null, " ");
        }
    };

    return (
        <div className="row bs_contract">
            <div className="col-lg-12">
                <div className="bs-card h-100">
                    <div className="p-3">
                        <div className="bs-tab">
                            <button
                                className={`bs-tab-item ${
                                    ["code"].includes(tab) ? "active" : ""
                                }`}
                                onClick={() => handleTab("code")}
                            >
                                {t("Code")}
                            </button>
                            {details?.has_methods_read && (
                                <button
                                    className={`bs-tab-item ${
                                        ["readContract"].includes(tab) ? "active" : ""
                                    }`}
                                    onClick={() => handleTab("readContract")}
                                >
                                    {t("Read Contract")}
                                </button>
                            )}
                            {details?.has_methods_read_proxy && (
                                <button
                                    className={`bs-tab-item ${
                                        ["readProxyContract"].includes(tab) ? "active" : ""
                                    }`}
                                    onClick={() => handleTab("readProxyContract")}
                                >
                                    {t("Read Proxy")}
                                </button>
                            )}
                            {details?.has_methods_write && (
                                <button
                                    className={`bs-tab-item ${
                                        ["writeContract"].includes(tab) ? "active" : ""
                                    }`}
                                    onClick={() => handleTab("writeContract")}
                                >
                                    {t("Write Contract")}
                                </button>
                            )}
                            {details?.has_methods_write_proxy && (
                                <button
                                    className={`bs-tab-item ${
                                        ["writeProxyContract"].includes(tab) ? "active" : ""
                                    }`}
                                    onClick={() => handleTab("writeProxyContract")}
                                >
                                    {t("Write Proxy")}
                                </button>
                            )}
                            {details?.is_verified && (
                                <button
                                    className={`bs-tab-item ${
                                        ["aiAuditAnalysis"].includes(tab) ? "active" : ""
                                    }`}
                                    onClick={() => handleTab("aiAuditAnalysis")}
                                >
                                    {t("AI Audit")}
                                </button>
                            )}
                        </div>

                        <div className="bs-tab-content">
                            {["code"].includes(tab) && <ReadCode isActive={true}/>}
                            {["readContract"].includes(tab) && (
                                <ReadWriteContract
                                    isRead={true}
                                    isProxy={false}
                                    validChainId={false}
                                    metamaskAddress={""}
                                    implementation={props?.data?.implementation_address}
                                />
                            )}
                            {["readProxyContract"].includes(tab) && (
                                <ReadWriteContract
                                    isRead={true}
                                    isProxy={true}
                                    validChainId={false}
                                    metamaskAddress={""}
                                    implementation={props?.data?.implementation_address}
                                />
                            )}
                            {["writeContract"].includes(tab) && (
                                <ReadWriteContract
                                    isRead={false}
                                    isProxy={false}
                                    validChainId={true}
                                    metamaskAddress={""}
                                    implementation={props?.data?.implementation_address}
                                />
                            )}
                            {["writeProxyContract"].includes(tab) && (
                                <ReadWriteContract
                                    isRead={false}
                                    isProxy={true}
                                    validChainId={true}
                                    metamaskAddress={""}
                                    implementation={props?.data?.implementation_address}
                                />
                            )}
                            {["aiAuditAnalysis"].includes(tab) && <AuditPage/>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContractDetails;
